import { cn } from '@/lib/utils';
import { Check, ChevronsUpDown } from 'lucide-react';
import { Badge } from '../Badge';
import { Button } from '../Button';
import { Command, CommandGroup, CommandItem, CommandList } from '../Command';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover';

interface ComboboxFormFieldProps {
  value: string[];
  options: { value: string; label?: string }[];
  placeholder?: string;
  hasError?: boolean;
  modal?: boolean;
  canEdit?: boolean;
  onChange: (value: string[]) => void;
}

export const ComboboxFormField = ({
  value,
  options,
  placeholder,
  canEdit = true,
  modal = false,
  hasError,
  onChange,
}: ComboboxFormFieldProps) => {
  const currentValue = value ?? [];

  const toggleValue = (val: string) => {
    if (value.length === 1) {
      if (value[0] === val) {
        return;
      }
    }
    if (currentValue.includes(val)) {
      onChange(currentValue.filter((v) => v !== val));
    } else {
      onChange([...currentValue, val]);
    }
  };

  return (
    <Popover modal={modal}>
      <PopoverTrigger asChild disabled={!canEdit}>
        <Button
          variant="outline"
          role="combobox"
          className={`max-w-full justify-between ${hasError ? 'border-destructive' : ''}`}
        >
          <div className="flex gap-1">
            {currentValue.length > 0 ? (
              currentValue.sort().map((val, index) => (
                <Badge variant={'secondary'} key={index}>
                  <span className="capitalize">
                    {options.find((option) => option.value === val)?.label ??
                      options.find((option) => option.value === val)?.value}
                  </span>
                </Badge>
              ))
            ) : (
              <span className="text-muted-foreground">{placeholder}</span>
            )}
          </div>
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0">
        <Command>
          {/* <CommandInput placeholder={placeholder} className="h-9" /> */}
          <CommandList>
            {/* <CommandEmpty>Not found.</CommandEmpty> */}
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.value}
                  value={option.value}
                  onSelect={(currentValue) => {
                    toggleValue(currentValue);
                  }}
                  className="capitalize"
                >
                  {option.label ?? option.value}
                  <Check
                    className={cn(
                      'ml-auto',
                      currentValue.includes(option.value)
                        ? 'opacity-100'
                        : 'opacity-0',
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
